export default "__VITE_ASSET__NUa3TsYY__"